export default "__VITE_ASSET__ONB9DWCA__"